var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVuesax(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.702 1.037H6.297c-3.361 0-4.58 1.296-4.58 4.939v16.048c0 3.642 1.219 4.938 4.58 4.938h7.393c3.374 0 4.592-1.296 4.592-4.938V5.976c0-3.643-1.218-4.94-4.58-4.94ZM10 23.462c-1.17 0-2.132-1.023-2.132-2.268 0-1.244.963-2.268 2.132-2.268 1.17 0 2.131 1.024 2.131 2.268 0 1.245-.962 2.268-2.131 2.268Zm2.436-16.916H7.564c-.5 0-.914-.44-.914-.972s.415-.973.914-.973h4.872c.5 0 .913.441.913.973 0 .531-.414.972-.913.972Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesax);
export default __webpack_public_path__ + "static/media/vuesax.7f93af69ae6a4c82ce9e43eea392ec7d.svg";
export { ForwardRef as ReactComponent };